import { useCallback } from 'react';
import { isDesktop } from 'react-device-detect';
import { toast } from 'react-toastify';

import Cookies from 'js-cookie';

import { LaunchpadUserInfo, WalletType } from '@api';

import { storageKeys } from '@shared/constants';
import { formatWalletTypeCase } from '@shared/helpers/web3/formatWalletTypeCase';

import { useAuth } from '@launchpad/components/providers/AuthProvider/AuthProvider';

const useLaunchpadUserWalletInfo = () => {
  const { launchpadUser } = useAuth();

  const getUserWalletType = useCallback((): {
    walletType: WalletType;
    launchpadUser: LaunchpadUserInfo;
    address: string;
  } => {
    if (!launchpadUser) {
      throw new Error(`Something is wrong. Cannot find user wallet address`);
    }

    const savedConnectionType = Cookies.get(storageKeys.MSQ_CONNECTED_WALLET_TYPE);

    const walletType = formatWalletTypeCase(savedConnectionType);

    // TODO: Come up with a better solution to remove toast side effect and make it pure function
    if (!isDesktop && walletType === 'EVM') {
      toast.info('EVM wallets is only available by WalletConnect on Mobile.');
    }

    return {
      walletType: !isDesktop ? 'WalletConnect' : walletType ?? 'EVM',
      address: launchpadUser.attributes.address,
      launchpadUser,
    };
  }, [launchpadUser]);

  const getUserWalletAddress = useCallback((): {
    address: string;
    launchpadUser: LaunchpadUserInfo;
  } => {
    if (!launchpadUser) {
      throw new Error(`Something is wrong. Cannot find user wallet address`);
    }

    return {
      address: launchpadUser.attributes.address,
      launchpadUser,
    };
  }, [launchpadUser]);

  return {
    getUserWalletType,
    getUserWalletAddress,
  };
};

export default useLaunchpadUserWalletInfo;
